import * as fallbackImage from '../../images/default-fallback-image.png';
import getImageUrl, { getFeaturedImage } from '../util/getImage'

export default class {

  constructor() {
    this.page = 1
    this.events()
  }

  filterData( append = false ) {
    const that = this
    const $wrapper = $('.js-hotelFilters__cards')
    const $button = $('.js-hotelFilters__moreBtn')

    // eslint-disable-next-line
    let url = `${API_BASE_URL}/hotels?`

    const params = {}
    if ( this.page > 1 ) {
      params['page'] = this.page
    }
    if ( Object.keys(params) ) {
      url += $.param(params)
    }

    $wrapper.addClass('is-loading')
    $wrapper.append('<div class="l-spinner"><div class="l-spinner__el"></div></div>')

    $button.find('span').text('Loading...')
    $button.addClass('is-loading')
    $.get( url, function( response ) {
      if ( response.data.length ) {

          const markup = that.getMarkup( response.data )

          const $spinner = $('.l-spinner')
          if ( $spinner.length ) {
            $spinner.remove()
          }

          if ( append ) {
            $wrapper.append(markup)
          } else {
            $wrapper.html(markup)
          }

          $wrapper.removeClass('is-loading')
          $button.find('span').text('Show more')
          $button.removeClass('is-loading')

          if( response.meta.last_page === that.page ) {
            $button.hide()
          } else {
            $button.show()
          }
      } else {
        const noDataMarkup = `
          <div class="col-12 d-flex align-items-center justify-content-center mt-4">
            <p><strong>No hotels found</strong></p>
          </div>
        `
        $button.hide()
        $wrapper.html(noDataMarkup)
      }
    });
  }

  getMarkup(hotels) {
    if ( !hotels.length ) return

    let content = ''

    hotels.map( hotel => {
      const image = getImageUrl(getFeaturedImage(hotel.images), 'default', '559x327')
      content += `
          <div class="col-lg-4 col-md-6">
            <a href="/hotels/${hotel['slug']}" class="c-hotelCard c-hotelCard--simple l-card">
            <div class="c-hotelCard__imageWrapper h-objectImage h-objectImage--3by2 js-objectImage l-card__imageWrapper visible">
              ${
                image ? (
                  `
                    <img class="l-card__image" src="${ image }">
                  `
                ) : (
                  `<img class="l-card__image" src="${fallbackImage}">`
                )
              }
            </div>
            <div class="c-hotelCard__body l-card__body">
              <h2 class="c-hotelCard__title l-card__title h5">${hotel['name']}</h2>
              <p class="c-hotelCard__address">
              ${
                ( hotel['addr_city'] || hotel['addr_county'] ) && (
                  `${hotel['addr_city'] ? ( hotel['addr_city'] + ', ' )  : ''}${hotel['addr_county'] || ''}`
                )
              }
              </p>
            </div>
          </a>
        </div>
      `
    })
   return content
  }

  events() {
    $('.js-hotelFilters__moreBtn').on('click', (e) => {
      e.preventDefault()
      this.page++
      this.filterData(true)
    })
  }

}
